var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{content:true,'exp-left':_vm.expLeft,'exp-right':_vm.expRight,'view-mode':_vm.viewMode}},[_c('content-left'),_vm._v(" "),_c('content-middle',{ref:"middle",on:{"panelExp":_vm.onPanelExp}}),_vm._v(" "),_c('content-right')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a7f9f63","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/layout/layout.vue
// module id = null
// module chunks = 